<!-- Game Board -->
<div class="board">
    <app-snake></app-snake>
    <app-ladder></app-ladder>
    <app-go></app-go>
</div>
